import { types, actions } from './requests'
export const UPDATETASK_TYPES = {
    ...types('UPDATETASK'),
}
export const UPDATETASK_ACTIONS = {
    ...actions('UPDATETASK'),
}